import { IClientAuthDTO } from "@hooks/dtos/IClientDTO";
import { IdentifiedPanel } from "./IdentifiedPanel";
import { VerifiedPanel } from "./VerifiedPanel";
import { ClientSessionStageEnum } from "@hooks/dtos/IClientSessionDTO";

interface IProps {
  client: IClientAuthDTO;
}

export const UserMiniPanel = ({ client }: IProps) => {
  switch (client.stage) {
    case ClientSessionStageEnum.IDENTIFIED:
      return <IdentifiedPanel client={client} />;

    case ClientSessionStageEnum.VERIFIED:
      return <VerifiedPanel client={client} />;

    default:
      // Return null or a fallback button when no case matches
      return <></>;
  }
};
